<template>
  <div class="entrust-talbe" v-loading="!detailData.reportCode">
    <table class="word-table">
      <tr>
        <td width="20%">
          <span class="label">委托单位</span>
        </td>
        <td width="30%">
          {{ detailData.client }}
        </td>
        <td width="20%">
          <span class="label">工程名称</span>
        </td>
        <td width="30%">
          {{ detailData.projectName || '/' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">付款单位名称</span>
        </td>
        <td>
          {{ detailData.payOrg || '/' }}
        </td>
        <td>
          <span class="label">施工单位</span>
        </td>
        <td>
          {{ detailData.builder || '/' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">送检人</span>
        </td>
        <td>
          {{ detailData.sfcn }}
        </td>
        <td>
          <span class="label">联系电话</span>
        </td>
        <td>
          {{ detailData.sfcp }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">送检人地址</span>
        </td>
        <td>{{ detailData | sfcaFilter }}</td>
        <td>
          <span class="label">检测类别</span>
        </td>
        <td>
          {{ detailData.testTypeText }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">监理单位</span>
        </td>
        <td>
          {{ detailData.supervisionUnit || '/' }}
        </td>
        <td>
          <span class="label">监理见证人</span>
        </td>
        <td>
          {{ detailData.supervisionPerson || '/' }}
        </td>
      </tr>
    </table>

    <table class="word-table" v-if="detailData.etmtType == 'etmt_type_unvs'">
      <tr>
        <td colspan="6">
          <span class="label">样品信息描述</span>
        </td>
      </tr>
      <tr>
        <td width="18%" class="label">样品名称</td>
        <td width="12%" class="label">规格型号</td>
        <td width="6%" class="label">单位</td>
        <td width="8%" class="label">数量</td>
        <td width="20%" class="label">生产厂家</td>
        <td width="12%" class="label">备注</td>
      </tr>
      <tr v-for="(item, index) in detailData.sampleInfoList" :key="index">
        <td>{{ item.sampleName }}</td>
        <td>{{ item.model }}</td>
        <td>{{ item.unit }}</td>
        <td>{{ item.cnt }}</td>
        <td>{{ item.manufacturer || '/' }}</td>
        <td>{{ item.remark || '/' }}</td>
      </tr>
    </table>

    <table
      v-if="
        detailData.etmtType == 'etmt_type_dx' ||
        detailData.etmtType == 'etmt_type_yjjsjj' ||
        detailData.etmtType == 'etmt_type_xcxj'
      "
      class="word-table"
    >
      <tr>
        <td width="18%" class="label">样品名称</td>
        <td width="10%" class="label">数量（根）</td>
        <td width="16%" class="label">规格</td>
        <td width="24%" class="label">生产厂家</td>
        <td width="10%" class="label">计算拉断力（kN）</td>
        <td width="10%" class="label">握力值要求（kN）</td>
        <td width="10%" class="label">放线时间</td>
      </tr>
      <tr v-for="(item, index) in detailData.sampleInfoList" :key="index">
        <td>{{ item.sampleName }}</td>
        <td>{{ item.cnt }}</td>
        <td>{{ item.model }}</td>
        <td>{{ item.manufacturer }}</td>
        <td>{{ item.ll }}</td>
        <td>{{ item.wl }}</td>
        <td>{{ item.stoTime }}</td>
      </tr>
    </table>

    <!-- 导线类型 机械载荷实验 -->
    <table
      v-if="
        detailData.etmtType == 'etmt_type_dxph' ||
        detailData.etmtType == 'etmt_type_ljjj' ||
        detailData.etmtType == 'etmt_type_xcxjph'
      "
      class="word-table"
    >
      <tr>
        <td width="18%" class="label">样品名称</td>
        <td width="10%" class="label">数量（根）</td>
        <td width="14%" class="label">规格</td>
        <td width="22%" class="label">生产厂家</td>
        <td width="12%" class="label">机械损伤载荷（kN）</td>
        <td width="12%" class="label">标称破坏载荷（kN）</td>
        <td width="10%" class="label">放线时间</td>
      </tr>
      <tr v-for="(item, index) in detailData.sampleInfoList" :key="index">
        <td>{{ item.sampleName }}</td>
        <td>{{ item.cnt }}</td>
        <td>{{ item.model }}</td>
        <td>{{ item.manufacturer }}</td>
        <td>{{ item.ll }}</td>
        <td>{{ item.wl }}</td>
        <td>{{ item.stoTime }}</td>
      </tr>
    </table>

    <table class="word-table">
      <tr>
        <td width="20%">
          <span class="label">检测项目</span>
        </td>
        <td width="80%" class="label">依据的标准名称及编号(含年号)</td>
      </tr>
      <tr v-for="(item, index) in tesetItemData" :key="index">
        <td>
          <span>{{ item.itemName }}</span>
        </td>
        <td>{{ item.basisName }}</td>
      </tr>
      <tr>
        <td>
          <span class="label">是否接受分包至其他有资质的检测机构</span>
        </td>
        <td>
          {{ detailData.isSbct == 1 ? '是' : '否' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">出具报告类型</span>
        </td>
        <td>
          {{ detailData.reportType == 0 ? '合格样品报告' : '合格样品报告、不合格样品报告' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">样品处理方式</span>
        </td>
        <td>
          {{
            detailData.sampleDealWay == 0
              ? '自取'
              : detailData.sampleDealWay == 1
              ? '样品所有权转归受托方，并全权处置'
              : '破坏性实验样品留存三个月'
          }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">报告领取方式</span>
        </td>
        <td>
          {{ detailData.deliveryType == 0 ? '自取' : '邮寄（到付）' }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">服务类型</span>
        </td>
        <td>
          {{ detailData.serviceType | serviceTypeFilter }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="label">特殊说明</span>
        </td>
        <td>
          {{ detailData.note || '/' }}
        </td>
      </tr>
    </table>
    <table class="word-table">
      <tr>
        <td width="50%">
          <div class="sign-box">
            <div>我方保证对样品信息（资料）的真实性负责，提供必要的合作，并保证在出具正式检测报告前支付检测费用</div>
            <div class="sign-line">
              委托单位或代表签字（盖章）：
              <img class="sign-image" v-if="detailData.clientSign" :src="$imgUrl + detailData.clientSign" />
            </div>
            <div>申请日期：{{ detailData.applyDate || '' }}</div>
          </div>
        </td>
        <td width="50%">
          <div class="sign-box">
            <div>本单位保证检测的公正性，对检测数据负责，本公司承诺对委托单位提供的实物和技术资料保密</div>
            <div class="sign-line">
              承检单位签字（盖章）：
              <img class="sign-image" v-if="detailData.inspUnitSign" :src="$imgUrl + detailData.inspUnitSign" />
            </div>
            <div>接样时间：{{ detailData.receiptDate }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="align-Left">
          <div class="txt">说明:</div>
          <div class="txt">1.本协议书一式二联，第一联公司留存，第二联交客户作为取报告的凭证；</div>
          <div class="txt">2.委托单位未指定或者未填写检测依据，则视同本单位所选检测依据；</div>
          <div class="txt">3.如无特殊说明，检测报告一式三份，交由客户；</div>
          <div class="txt">4.本公司出具的检测报告仅对样品负责；</div>
          <div class="txt">
            5.如样品中含有任何潜在的危险性，如有毒、爆炸性、放射性或有严重干扰的样品，委托单位须事先声明，否则后果由委托单位承担；
          </div>
          <div class="txt">
            6.如委托单位需本单位外出现场检测，则委托单位需确保现场检测场所无任何可能危及或影响现场检测人员安全的危险因素，否则由此给现场检测人员或本单位造成一切损失由委托单位承担。
          </div>
          <div class="txt">7.如对本报告检测结果有异议，请于报告签发之日起十五日内以书面形式向本单位提出,逾期不予受理。</div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    tesetItemData() {
      return JSON.parse(this.detailData.basisJson || '[]');
    }
  },
  filters: {
    sfcaFilter(val) {
      if (!val.sfca1 && !val.sfca2 && !val.sfca3 && !val.sfca) {
        return '/';
      } else {
        return '' + val.sfca1 + val.sfca2 + val.sfca3 + val.sfca;
      }
    },
    serviceTypeFilter(val) {
      switch (val) {
        case 7:
          return '标准服务7个工作日';
        case 14:
          return '14个工作日';
        case 28:
          return '28个工作日';
        case 4:
          return '加急服务4个工作日，加收50%检测费';
        case 2:
          return '特急服务2个工作日，加收100%检测费';
        default:
          return '';
      }
    }
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.sign-box {
  text-align: left;

  > div:first-of-type {
    text-indent: 2em;
  }
  .sign-line {
    display: flex;
    align-items: center;
    height: 50px;
  }
  .sign-image {
    width: 80px;
    height: auto;
  }
}
</style>
